var _defs, _metadata, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGebasz(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    viewBox: "0 0 220.083 193.459",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), /*#__PURE__*/React.createElement("g", {
    id: "Layer_x0020_1"
  }, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", {
    id: "CorelCorpID_0Corel-Layer"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_144798103088"
  }, /*#__PURE__*/React.createElement("path", {
    className: "svgBg",
    style: {
      strokeWidth: 7.147,
      strokeMiterlimit: 22.9256
    },
    d: "M116.16 7.177l49.696 86.076 49.737 86.147c2.611,5 -0.632,10.462 -6.136,10.486l-99.392 0 -99.474 0c-5.635,-0.24 -8.744,-5.779 -6.013,-10.558l49.696 -86.075 49.737 -86.147c3.025,-4.761 9.377,-4.684 12.149,0.071z"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "svgText",
    d: "M107.868 122.326l4.347 0c1.223,0 2.445,-1.087 2.581,-2.174l5.298 -38.171 0 -15.215c0,-1.358 -1.223,-2.581 -2.581,-2.581l-14.943 0c-1.358,0 -2.58,1.223 -2.58,2.581l0 15.486 5.297 37.9c0.136,1.087 1.359,2.174 2.581,2.174zm-8.965 27.168c0,6.113 5.026,11.139 11.003,11.139 6.249,0 11.275,-5.026 11.275,-11.139 0,-6.113 -5.026,-11.275 -11.275,-11.275 -5.977,0 -11.003,5.162 -11.003,11.275z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGebasz);
export default __webpack_public_path__ + "static/media/gebasz.897608ba934d4d7fc09e878553dc69dd.svg";
export { ForwardRef as ReactComponent };